import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductSchedule } from '@/features/schedule'

export const Route = createFileRoute('/_event/programacao')({
  component: DigitalProductSchedulePage
})

function DigitalProductSchedulePage() {
  const digitalProductId = useRouteDigitalProductId()

  return <DigitalProductSchedule digitalProductId={digitalProductId} />
}
